<template>
  <div id="iDDUserPortal" class="micor-app-box"></div>
</template>

<script>
const getActiveRule = hash => location => location.hash.startsWith(hash)
import { loadMicroApp } from 'qiankun'
export default {
  name: 'iDDUserPortal',
  data() {
    return {
      microApp: null,
    }
  },
  watch: {
    $route: function(val, oldVal) {
      this.microApp.update({ routeChange: { to: val, from: oldVal } })
    },
  },
  methods: {},
  mounted() {
    this.$store.commit('updateProduct', 'idd')
    let currentRoute = this.$route.fullPath
    this.microApp = loadMicroApp(
      {
        name: 'iDDUserPortal', //应用名字
        entry:
          process.env.NODE_ENV === 'production'
            ? '/userPortal/'
            : '//localhost:9999', //默认会加载这个HTML 动态加载资源 （必须支持跨域）
        // fetch
        container: '#iDDUserPortal', //容器名
        activeRule: getActiveRule('#/childiDDUserPortal'), //激活路径
        props: {
          fatherRouter: this.$router,
          currentRoute,
        },
      },
      {
        singular: false,
      }
    )
  },
  beforeDestroy() {
    this.microApp.unmount()
    this.$store.commit('updateProduct', '')
  },
}
</script>

<style scoped></style>
